module.exports = "/_next/static/images/Reliability-863735fc7367260f98b8fbe5617cf886.webp";